module.exports = __webpack_public_path__ + "img/CX.f5058fd8.png";